import initialState from './initialState';
import { types } from '../actions/publicSurveyActions';
import { SurveyModel } from '../models/survey/SurveyModel';
import { FormQuestionTypes } from '../models/survey/FormQuestionTypes';

export default function publicSurveyDetailsReducer(state = initialState.publicSurveyDetails, action) {
  switch (action.type) {
    case types.GET_PUBLIC_SURVEY: {
      return { fetching: true };
    }
    case types.GET_PUBLIC_SURVEY_SUCCESS: {
      const { survey } = action;
      const data = Object.assign(new SurveyModel(), survey);
      if (data.form) {
        data.form.forEach(item => {
          if (item.questionType === FormQuestionTypes.iconRating) item.scale = item.answers.length;
        });
      }
      return {
        fetching: false,
        data: data,
      };
    }
    case types.GET_PUBLIC_SURVEY_FAILURE: {
      return { fetching: false, data: null };
    }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/publicSurveyDetailsReducer.js